import { version } from "../package.json";
import { AllChainsService } from "./services/AllChainsService";
import { BalanceService } from "./services/BalanceService";
import { BaseService } from "./services/BaseService";
import { BitcoinService } from "./services/BitcoinService";
import { NftService } from "./services/NftService";
import { PricingService } from "./services/PricingService";
import { SecurityService } from "./services/SecurityService";
import { TransactionService } from "./services/TransactionService";
import { Execution } from "./utils/functions/execution";
import { isValidApiKey } from "./utils/functions/isValidApiKey";
import {
  type GoldRushClientSettings,
  type GoldRushResponse,
} from "./utils/types/Generic.types";

/**
 * GoldRushClient Class
 */
export class GoldRushClient {
  private readonly userAgent: string = `com.covalenthq.sdk.typescript/${version}`;

  public AllChainsService: AllChainsService;
  public BalanceService: BalanceService;
  public BaseService: BaseService;
  public BitcoinService: BitcoinService;
  public NftService: NftService;
  public PricingService: PricingService;
  public SecurityService: SecurityService;
  public TransactionService: TransactionService;

  constructor(apiKey: string, settings: GoldRushClientSettings = {}) {
    const validKey: boolean = isValidApiKey(apiKey);

    if (!validKey) {
      throw {
        data: null,
        error: true,
        error_code: 401,
        error_message:
          "Invalid or missing API key (sign up at https://goldrush.dev/platform/apikey)",
      } as GoldRushResponse<null>;
    }

    const execution: Execution = new Execution(settings, {
      Authorization: `Bearer ${apiKey}`,
      "X-Requested-With": settings.source
        ? `${settings.source} (${this.userAgent})`
        : this.userAgent,
    });

    this.AllChainsService = new AllChainsService(execution);
    this.BalanceService = new BalanceService(execution);
    this.BaseService = new BaseService(execution);
    this.BitcoinService = new BitcoinService(execution);
    this.NftService = new NftService(execution);
    this.PricingService = new PricingService(execution);
    this.SecurityService = new SecurityService(execution);
    this.TransactionService = new TransactionService(execution);
  }
}
